import {axios} from '../../services/axios';
import {query} from '../../utils/utils';
export default function getDRServiceProfileVoicePolicies({scope, regions}) {
    return axios.get(
        `/ServiceProfiles/DirectRouting/${scope}/VoicePolicies/Available?RegionIDs=${query(
            regions,
        )}`,
    );
}
